// src/utils/errorHandler.js
import { ref } from 'vue';

// ������Ӧʽ�Ĵ������������
const NotificationManagerRef = ref(null);

// ���ô���������ķ���
export function setNotificationManager(manager) {
    NotificationManagerRef.value = manager;
}

// ��ʾȫ�ִ���ķ���
export function showGlobalNotification(message, type='info') {
    if (NotificationManagerRef.value) {
        NotificationManagerRef.value.addMessage(message, type);
    } else {
        // �󱸷�����ʹ�������ԭ�� alert
        console.error('ȫ�ִ���:', message);
        alert(message);
    }
}

// ����δ����� Promise �쳣
export function setupGlobalNotificationHandling() {
    window.addEventListener('unhandledrejection', event => {
        const message = `δ��������: ${event.reason?.message || event.reason || 'δ֪����'}`;
        showGlobalNotification(message, 'error');
    });

    window.addEventListener('error', event => {
        const message = `ȫ�ִ���: ${event.message || 'δ֪����'}`;
        showGlobalNotification(message, 'error');
    });
}